export default "__VITE_ASSET__T0fFkwxe__"